import { render, staticRenderFns } from "./searchVttk.vue?vue&type=template&id=ecad16c2&scoped=true"
import script from "./searchVttk.vue?vue&type=script&lang=js"
export * from "./searchVttk.vue?vue&type=script&lang=js"
import style0 from "./searchVttk.vue?vue&type=style&index=0&id=ecad16c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecad16c2",
  null
  
)

export default component.exports